import CarouselHourlyItem from "./CarouselHourlyItem";

export default CarouselHourlyItem;
